import { render, staticRenderFns } from "./base-labels-picker.vue?vue&type=template&id=5f68b2f7&scoped=true&"
import script from "./base-labels-picker.vue?vue&type=script&lang=js&"
export * from "./base-labels-picker.vue?vue&type=script&lang=js&"
import style0 from "./base-labels-picker.vue?vue&type=style&index=0&id=5f68b2f7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f68b2f7",
  null
  
)

export default component.exports